import {useMutation} from '@tanstack/react-query'
import api, {CreateApiKeysParams} from 'src/services/api'

export default function useCreateApiKey() {
  const mutation = useMutation({
    mutationFn: async (body: CreateApiKeysParams) => {
      return await api.auth.createApiKey(body)
    },
  })
  return mutation
}
